import React, { useEffect, useState } from 'react';
import { TCETileContainer, MTitle, CEdata } from '../CarbonDashBoard.styles';
import {
  TOTAL_CARBON_EMISSION,
  CARBON_EMISSION,
  MARGIN_CARBON_RATIO,
  MARGIN_TO_CARBON_RATIO,
  NET_CARBON_INTENSITY,
  two,
} from '../../../constants';
import Carbonemissionstat from '../../Carbonemissionstat';
import { ICarbonData, IDataYear } from '../../../Types/types';

interface CarbonEmissionCardProps {
  currentYear: number;
  emissionType: string;
  data: ICarbonData[];
  isLeRefresh?: boolean;
}
const CarbonEmissionCard: React.FC<CarbonEmissionCardProps> = ({
  currentYear,
  emissionType,
  data,
  isLeRefresh
}) => {
  const [responseData, setResponseData] = useState<ICarbonData[]>([]);
  //setting the current date and next 5yrs
  const yearsToAdd = 4;
  const nextYear = currentYear + yearsToAdd;
  useEffect(() => {
    setResponseData(data);
  }, [data]);

  // Total Carbon Emission calculation
  const carbonEmissionCurrentYear = responseData?.filter(
    (carbonEmissionData: IDataYear) =>
      carbonEmissionData.TRADE_YEAR >= currentYear && carbonEmissionData.TRADE_YEAR <= nextYear,
  )?.[0]?.[CARBON_EMISSION];

  // Margin To Carbon Emission calculation
  const currentYearMarginRatio = responseData?.filter(
    (marginRatioData: IDataYear) => marginRatioData.TRADE_YEAR === currentYear,
  )?.[0]?.[MARGIN_CARBON_RATIO];

  // Carbon Emission Card data
  let title = TOTAL_CARBON_EMISSION;
  let statusLabel2 = isLeRefresh ? 'MTPA' : '';
  let statusLabel = isLeRefresh ? carbonEmissionCurrentYear?.toFixed(two) : 'NA';
  const statusBgColor = '#F1F4F9';
  const textcolor = '#4B78AA';
  if (emissionType === MARGIN_TO_CARBON_RATIO) {
    title = MARGIN_TO_CARBON_RATIO;
    statusLabel2 = 'USD/T';
    statusLabel = currentYearMarginRatio?.toString();
  } else if (emissionType === NET_CARBON_INTENSITY) {
    title = NET_CARBON_INTENSITY;
  }

  return (
    <TCETileContainer>
      <MTitle>{`${title} (${currentYear})`}</MTitle>
      <CEdata>
        <Carbonemissionstat
          statusLabel2={statusLabel2}
          statusLabel={statusLabel}
          statusBgColor={statusBgColor}
          textcolor={textcolor}
        />
      </CEdata>
    </TCETileContainer>
  );
};
export default CarbonEmissionCard;
